module.exports = __webpack_public_path__ + "img/temp_dc2.c406173c.jpg";